import { FC } from "preact/compat";
import { FigureItemProps } from "./interfaces";
import { getCoords } from "./utils";

const ActiveFigureItem: FC<FigureItemProps> = ({ figure, pageSize }) => {
    const coords = getCoords(figure.boundaries);

    if (coords.length < 1) {
        return null;
    }

    const width = pageSize.width;
    const height = pageSize.height;

    const pathD = [
        `M 0 0 H ${width} V ${height} H 0 Z`,
        `M ${coords.map((c) => c.join(",")).join(" L ")} Z`,
    ].join(" ");

    return (
        <path d={pathD} fill="#434343" fillOpacity="0.7" fillRule="evenodd" />
    );
};

export default ActiveFigureItem;
